import React from 'react';
import {
  Box,
  FormGroup,
  Label,
  LabelText,
  DropDown,
  Input,
  CopyableHash,
} from '@zen-common/components-base';
import { SettingsStore, TechnicalData as TD } from '@zen/common-app-parts';

export default function OraclesDropDown({ items, value, onChange }) {
  const {
    state: {
      settings: { chain },
    },
  } = SettingsStore.useStore();

  const filterItems = React.useMemo(
    () => items.filter((o) => o.label && o.label.split(' ')[0] === chain),
    [chain, items]
  );

  const filterValue = React.useMemo(() => (value.chain === chain ? value : undefined), [
    chain,
    value,
  ]);

  React.useEffect(() => {
    if (!filterValue) onChange(filterItems[0]);
  }, [filterItems, filterValue, onChange]);

  return (
    <FormGroup mb="smd">
      <Label>
        <LabelText>Oracle Service Provider</LabelText>
      </Label>
      {filterItems.length > 1 ? (
        <DropDown items={filterItems} onChange={onChange} value={(filterValue || {}).address} />
      ) : (
        <Input
          inputType="expandable"
          readOnly
          variant="block"
          value={(filterValue || {}).address}
        />
      )}

      {filterValue && (
        <Box mt="2" mb="smd">
          <TD.Section>
            <Box>
              <TD.Label>Data Source:</TD.Label>
              <TD.Value>
                {filterValue.dataSource} {filterValue.dataSourceUrl}
              </TD.Value>
            </Box>
            <Box>
              <TD.Label>Oracle PublicKey:</TD.Label>
              <TD.Value>
                <CopyableHash hash={filterValue.publicKey} />
              </TD.Value>
            </Box>
            <Box>
              <TD.Label>Oracle Contract ID:</TD.Label>
              <TD.Value>
                <CopyableHash hash={filterValue.contractId} />
              </TD.Value>
            </Box>
            <Box>
              <TD.Label>Commit Data At:</TD.Label>
              <TD.Value>{filterValue.commitDataAt} (Eastern Daylight Time)</TD.Value>
            </Box>
          </TD.Section>
        </Box>
      )}
    </FormGroup>
  );
}
